import { render, staticRenderFns } from "./PortfolioManagerSiteDetails.vue?vue&type=template&id=935938de&"
import script from "./PortfolioManagerSiteDetails.vue?vue&type=script&lang=ts&"
export * from "./PortfolioManagerSiteDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports